import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_PROVIDER_DEMO_IEAM_3 = {
  title: "Capturing network\n intent and NEF APIs",
  subtitle: "Use case Provider demo",
  text: "The system also captures network-related \n intent, such as bandwidth and speed, and \n integrates with the relevant NEF APIs \n (CAMARA) applicable for the application.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_108"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_106"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_BG.png",
  rightSideImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_03.png",
};
